export const apiUrl = (path) => {
  const base = process.env.VUE_APP_API_URL || process.env.VUE_APP_API_BASE_URL || '';
  if (!base) return path;
  // For prod with base set: most endpoints do not include '/api' prefix, except '/api/place-details'
  const keepApi = path.startsWith('/api/place-details');
  const cleaned = keepApi ? path : path.replace(/^\/api(\/|$)/, '/');
  if (base.endsWith('/') && cleaned.startsWith('/')) return base + cleaned.slice(1);
  return base + cleaned;
};


